"use client";

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import Navbar from "../../../../../components/navbar";
import Footer from "../../../../../components/footer";
import Button from "../../../../../components/Button";
import styles from "../../Card/css/cardPayment.module.css";

export default function MedicalAidPaymentView() {
  const location = useLocation();
  const navigate = useNavigate();

  const [total, setTotal] = useState(0);
  const fromDebtors = !!(location.state && location.state.fromDebtors);

  useEffect(() => {
    if (location.state && typeof location.state.total === "number") {
      setTotal(location.state.total);
      return;
    }

    try {
      const raw = localStorage.getItem("frontshop_basket");
      if (raw) {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          const subtotal = parsed.reduce(
            (sum, item) => sum + (Number(item.price) || 0) * (Number(item.qty) || 0),
            0
          );
          const tax = subtotal * 0.15;
          setTotal(subtotal + tax);
        }
      }
    } catch {
      // ignore errors
    }
  }, [location.state]);

  const handleBack = () => {
    navigate("/frontshop/payment-types/split/medical-aid/profiles", {
      state: { total, fromDebtors },
    });
  };

  const handleMarkPaid = () => {
    navigate("/frontshop/payment-types/split/step2", {
      state: { total, method1: "medicalAid", fromDebtors },
    });
  };

  return (
    <div className={styles.wrapper}>
      <Navbar onBack={handleBack} />

      <main className={styles.main}>
        <div className={styles.card}>
          <div className={styles.header}>
            <h1 className={styles.title}>Medical Aid Payment</h1>
          </div>

          <section className={styles.totalSection}>
            <div className={styles.totalBox}>
              <div className={styles.totalLabel}>Total Paid</div>
              <div className={styles.totalAmount}>R {total.toFixed(2)}</div>
            </div>
          </section>

          <div className={styles.buttonsRow}>
            <Button
              type="button"
              variant="cancel"
              className={styles.backBtn}
              onClick={handleBack}
            >
              <FiArrowLeft style={{ marginRight: 6 }} />
              Back
            </Button>
            <Button
              type="button"
              variant="approve"
              className={styles.payBtn}
              onClick={handleMarkPaid}
            >
              Mark as paid
            </Button>
          </div>
        </div>
      </main>

      <div className={styles.footerWrapper}>
        <Footer />
      </div>
    </div>
  );
}
